import React, { useCallback, useState } from 'react';
import {
  Hint,
  HintCloseButton,
  HintContent,
  IconButton,
  Typography,
  Modal,
  ModalContent,
  ModalHeader,
  Portal,
} from 'fronton-react';
import { QuestionIcon } from '@fronton/icons-react';
import { cx } from 'linaria';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { useEffectOnce } from '@navi-toolbox/hooks';
import { icon, withHint, wrapper, modal } from './style';

type Props = {
  message: string;
  hint?: string;
  className?: string;
  onShowBlock?: (params?: unknown) => unknown;
  onShowHint?: (params?: unknown) => unknown;
  hintPlacement?:
    | 'left'
    | 'right'
    | 'top'
    | 'bottom'
    | 'bottom-end'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'right-start'
    | 'right-end'
    | 'left-start'
    | 'left-end';
};

export const Infobar: React.FC<Props> = ({
  message,
  hint,
  className = '',
  hintPlacement = 'top',
  onShowBlock,
  onShowHint,
}) => {
  const { mobile } = useBreakpoints() ?? {};
  const [show, setShow] = useState(false);
  const toggleHint = useCallback(() => {
    setShow((s) => !s);
    if (!show) onShowHint?.();
  }, [onShowHint, show]);
  useEffectOnce(() => {
    onShowBlock?.();
  });
  return (
    <div className={cx(wrapper, className, hint && withHint)} data-qa="infobar">
      <Typography variant="s" size="body_long" data-qa="infobar-message">
        {message}
      </Typography>
      {hint && (
        <Hint
          anchor={
            <IconButton
              variant="primary"
              size="m"
              aria-label="подсказка"
              data-qa="infobar-hint-button"
              onClick={toggleHint}
            >
              <QuestionIcon type="outline" size="m" color="control-primary" />
            </IconButton>
          }
          closeButton={<HintCloseButton onClick={() => setShow(false)} />}
          placement={hintPlacement}
          className={icon}
          open={!mobile && show}
        >
          <HintContent header={message} paragraph={hint} />
        </Hint>
      )}
      {mobile && show && (
        <Portal>
          <Modal
            className={modal}
            onClose={() => setShow(false)}
            size="m"
            variant="curtain"
            data-qa="infobar-modal"
            show={show}
          >
            <ModalHeader title={hint} />
            <ModalContent>
              <Typography variant="s" size="body_short">
                {message}
              </Typography>
            </ModalContent>
          </Modal>
        </Portal>
      )}
    </div>
  );
};
